export default "__VITE_ASSET__DKXorJvy__"